<template>
  <div class="pay-qr-code">
    <el-dialog title="支付方式" :visible.sync="visible" width="360px" top="calc((100vh - 240px) / 2)" :close-on-click-modal="false" :before-close="closeDialog">
      <div class="content-center">
        <img :src="'data:image/jpeg;base64,' + payImg" width="200px" height="200px" />
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">取消</el-button>
        <el-button size="small" type="primary" @click="closeDialog">确认</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { httpAjax } from "@/api/ajax";

export default {
  name: "PayQrCode",
  props: {
    visible: Boolean,
    payPrice: Number | String
  },
  data(){
    return{
      payImg: '',

      formValidate: {
        mainImage: '',
      },
      ruleValidate: {
        mainImage: [
          {required: true, message: '请上传封面', trigger: 'blur'}
        ],
      },
      //裁切图片参数
      cropperModel:false,
      cropperName:'',
      imgName: '',
      imgVisible: false,
      
      action: '/services/user/uploadAvatar',
      headers: {'token': localStorage.getItem('userToken')},
      dialogVisible:false,
      imageUrl: null,
    }
  },
  created(){
    this.getPayImg()
  },
  methods:{
    // 获取支付二维码
    getPayImg(){
      httpAjax({
        url: "/services/pay/icqrcode",
        method: "get",
        data: {
          amount: this.payPrice
        }
      }).then((response) => {
        console.log(response)
        if(response.success){
          this.payImg = response.data && response.data.qrcodeUrl
        } else {
          this.closeDialog()
          this.$message({
            message: response.msg,
            type: "error",
          })
        }
      })
    },
    base64ToBlob(base64Data) {
      let arr = base64Data.split(','),
          fileType = arr[0].match(/:(.*?);/)[1],
          bstr = atob(arr[1]),
          l = bstr.length,
          u8Arr = new Uint8Array(l);
          
      while (l--) {
          u8Arr[l] = bstr.charCodeAt(l);
      }
      return new Blob([u8Arr], {
          type: fileType
      });
    },
    blobToFile(newBlob, fileName) {
      newBlob.lastModifiedDate = new Date();
      newBlob.name = fileName;
      return newBlob;
    },

     //封面设置
    uploadPicture(name){
      this.cropperName = name;
      this.cropperModel = true;
    },
    //图片上传成功后
    handleUploadSuccess (data){
      console.log(data)
      switch(data.name){
        case 'flagImg':
          this.formValidate.mainImage = 'http://ydfblog.cn/dfs/'+data.url;
          console.log('最终输出'+data.name)
          break;
      }
      this.cropperModel = false;
    },
    //  保存
    onSubmitstep(){
      this.$refs.cropperImage.$refs.cropper.getCropData(data => { //获取截图的base64格式数据
        console.log(data)

        const blob = this.base64ToBlob(data);
        const file = this.blobToFile(blob, '123.jpg');
        console.log(file)
        let formData = new FormData();
        formData.append('file',file,"DX.jpg")
        //调用axios上传
        httpAjax({
          url:'/services/user/uploadAvatar',
          method:'post',
          data: formData
        }).then((res) => {
          if(res.success){
            httpAjax({
              url:'/services/user/update/my',
              method:'put',
              data: {avatar:res.data}
            }).then((response) => {
              if(response.success) {
                this.$message({
                  message: '用户头像修改成功',
                  type: 'success'
                })
                this.$emit('uploadSuccess')
                this.$parent.imageVisible = false
              } else {
                this.$message({
                  message: response.msg,
                  type: 'error'
                })
              }
            });
          }
        })

        
      });
      
      
    },
       // 上传成功
    uploadSuccess(response) {
      console.log(response)
      if(response.success) {
        this.imageUrl = response.data
      } else {
        this.$message({
          message: response.msg,
          type: 'error'
        })
      }
    },
    // 删除图片
    removeImg(file, fileList) {
      setTimeout(()=>{
        this.imageUrl  = null
      },800)
    },
    //  关闭
    closeDialog(){
      this.$emit('closeDialog')
    }
  }
}
</script>

<style scoped lang="less">
</style>